import { render, staticRenderFns } from "./StockCustomerStatistics.vue?vue&type=template&id=4927b2e0&"
import script from "./StockCustomerStatistics.vue?vue&type=script&lang=ts&"
export * from "./StockCustomerStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports